import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'app-money-back-guarantee-bottomsheet',
  imports: [],
  templateUrl: './money-back-guarantee-bottomsheet.component.html',
})
export class MoneyBackGuaranteeBottomsheetComponent {
  constructor(
    private readonly bottomSheet: MatBottomSheet,
    private readonly eventLogger: EventLoggerService,
    private readonly router: Router
  ) {}

  closeBottomSheet(): void {
    this.bottomSheet.dismiss();
  }

  ctaClick(): void {
    this.bottomSheet.dismiss();
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'MBG_view_eligibility_criteria' }));
    this.router.navigate(['/moneyback-guarantee']);
  }
}
